module.exports = "/dist/assets/images/clock.svg";